import React, { useState } from 'react';

import questions from '../../data/questions';
import calculateRisk from '../../util/calculateRisk';

import ProgressBar from './ProgressBar';
import Navigation from './Navigation';
import QuestionStep from './QuestionStep';
import MultiQuestionStep from './MultiQuestionStep';
import ContactGate from './ContactGate';
import Result from './Result';

import { useIntl } from '../../util/reactIntl';
import { H2 } from '../Heading/Heading';

import css from './RiskCalculator.module.css';

function RiskCalculator() {
  const intl = useIntl();

  const [screen, setScreen] = useState('questions');

  const [currentStep, setCurrentStep] = useState(0);

  const [answers, setAnswers] = useState({
    projectType: null,
    siteSize: null,
    materials: [],
    occupied: null,
    theftHistory: null,
  });

  const [result, setResult] = useState(null);

  const question = questions[currentStep];

  const updateAnswer = (key, value) => {
    setAnswers(prev => ({
      ...prev,
      [key]: value,
    }));
  };

  const canContinue = () => {
    switch (question.id) {
      case 'projectType':
        return answers.projectType !== null;

      case 'siteSize':
        return answers.siteSize !== null;

      case 'materials':
        return answers.materials.length > 0;

      case 'occupied':
        return answers.occupied !== null;

      case 'theftHistory':
        return answers.theftHistory !== null;

      default:
        return false;
    }
  };

  const next = () => {
    if (currentStep < questions.length - 1) {
      setCurrentStep(prev => prev + 1);
    } else {
      setScreen('contact');
    }
  };

  const previous = () => {
    if (currentStep > 0) {
      setCurrentStep(prev => prev - 1);
    }
  };

  const showResult = () => {
    const r = calculateRisk(answers, questions);
    setResult(r);
    setScreen('result');
  };

  const restart = () => {
    setAnswers({
      projectType: null,
      siteSize: null,
      materials: [],
      occupied: null,
      theftHistory: null,
    });

    setCurrentStep(0);
    setResult(null);
    setScreen('questions');
  };

  if (screen === 'contact') {
    return (
      <div className={css.root}>
        <div className={css.container}>
          <ContactGate
            answers={answers}
            onSubmit={showResult}
          />
        </div>
      </div>
    );
  }

  if (screen === 'result') {
    return (
      <div className={css.root}>
        <div className={css.container}>
          <Result
            result={result}
            onRestart={restart}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={css.root}>
      <div className={css.container}>

        {/* TITLE */}
        <H2 className={css.calculatorTitle}>
          {intl.formatMessage({
            id: 'RiskCalculator.contact.title',
          })}
        </H2>

        {/* PROGRESS */}
        <ProgressBar
          current={currentStep + 1}
          total={questions.length}
        />

        {/* STEP */}
        <div className={css.stepLabel}>
          SCHRITT {currentStep + 1} VON {questions.length}
        </div>

        {/* QUESTION */}
        {question.multiple ? (
          <MultiQuestionStep
            question={question}
            selected={answers[question.id]}
            updateAnswer={updateAnswer}
          />
        ) : (
          <QuestionStep
            question={question}
            selected={answers[question.id]}
            updateAnswer={updateAnswer}
          />
        )}

        {/* NAVIGATION */}
        <Navigation
          current={currentStep}
          total={questions.length}
          canContinue={canContinue()}
          onPrevious={previous}
          onNext={next}
        />

      </div>
    </div>
  );
}

export default RiskCalculator;